import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

/**
 * CRM Phase 2 — safe client configuration (flags, limits, enums).
 * Rollout gate only: when `visible` is false the whole surface is hidden AND the
 * backend answers 404, so hiding navigation is UX, never the authorization.
 */
export default function useCrmConfig() {
  const { data, isLoading } = useQuery({
    queryKey: ["crm-config"],
    queryFn: async () => (await api.get("/crm/config")).data,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return {
    loading: isLoading,
    visible: Boolean(data?.visible),
    limits: data?.limits || {},
    enums: data?.enums || {},
  };
}
